import { render, staticRenderFns } from "./DeleteShipmentModal.vue?vue&type=template&id=6fecde9d&scoped=true&"
import script from "./DeleteShipmentModal.vue?vue&type=script&lang=js&"
export * from "./DeleteShipmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fecde9d",
  null
  
)

export default component.exports